var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-filter"},_vm._l((_vm.suite),function(h){return _c('active-button',{key:h,attrs:{"active":h === _vm.hours},on:{"click":function($event){return _vm.$emit('change', h)}}},[_vm._v("\n    "+_vm._s(h === 0 ? _vm.$t('filters.time.all') : h + _vm.$t('filters.time.h'))+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd4e4fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeFilter.vue
// module id = null
// module chunks = 